import { parse } from 'query-string';
import { useHistory, useLocation } from 'react-router';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { StoreState } from '@mm/state/store-interfaces';
import { INVALID_INVITE_ERROR_CODE } from '@mm/state/errorHandlers/facebook-session-handler';
import { Routes } from '../../routes/top-level-routes';

export const useInviteQuery = () => {
  const history = useHistory();
  const { search } = useLocation();
  const { companyId, companyName: queryCompanyName, errorCode } = parse(search);

  const storeCompanyName = useSelector(
    (state: StoreState) => state.session.inviteCompanyName,
  );

  const companyName = queryCompanyName || storeCompanyName;

  const isInvalidInviteTokenRedirect =
    parseInt(String(errorCode), 10) === INVALID_INVITE_ERROR_CODE;

  useEffect(() => {
    if (isInvalidInviteTokenRedirect) {
      history.push(Routes.inviteError.getLink());
    }
  }, [isInvalidInviteTokenRedirect]);

  return { companyId, companyName };
};
